(ns client-portal.client.routes)

(def routes {:home {:uri "/"}

             #_conversations
             :conversations/list {:uri "/conversations/list"
                                  :roles [:some [:conversations-admin]]
                                  :dispatch [:conversations/list-go-with-params]
                                  :label "Conversation Console"}

             #_drive-thru
             :drive-thru/locations-list {:uri "/drive-thru/locations"
                                         :roles [:some [:drive-thru-admin]]
                                         :dispatch [:drive-thru/locations-list-go-with-params]
                                         :label "Drive-Thru Management"}
             :drive-thru/location {:uri "/drive-thru/location/:concept-id/:location-id"
                                   :roles [:some [:drive-thru-admin]]}

             :drive-thru/post {:uri "/drive-thru/location/:concept-id/:location-id/:mac-address"
                               :roles [:some [:drive-thru-admin]]}

             #_voice-commerce
             :vc {:uri "/vc"
                  :roles [:some [:voice-commerce-user]]
                  :label "Dashboard"}
             :vc/orders {:uri "/vc/orders"
                         :roles [:some [:voice-commerce-user]]
                         :label "Orders"}

             #_voice-insights
             :vi {:uri "/vi"
                  :roles [:some [:voice-insights-user]]
                  :label "Dashboard"}
             :vi/locations {:uri "/vi/locations"
                            :roles [:some [:voice-insights-user]]
                            :label "Locations"}
             :vi/sessions {:uri "/vi/sessions"
                           :roles [:some [:voice-insights-user]]
                           :label "Sessions"}
             :vi/items {:uri "/vi/items"
                        :roles [:some [:voice-insights-user]]
                        :label "Items"}
             :vi/ces {:uri "/vi/ces"
                      :roles [:some [:voice-insights-user]]
                      :label "Customer Effort Scores"}
             :vi/duration {:uri "/vi/duration"
                           :roles [:some [:voice-insights-user]]
                           :label "Duration"}
             :vi/upsell {:uri "/vi/upsell"
                         :roles [:some [:voice-insights-user]]
                         :label "Upsell"}
             :vi/ai-analyst {:uri "/vi/ai-analyst"
                             :roles [:some [:admin]]
                             :label "AI Analyst"}
             ;; The Voice Insights summary agent, resolved from the user's agent list
             ;; (no ?agentId, no agent picker) — see chat.data/vi-summary-agent-routes.
             :vi/agent {:uri "/vi/agent"
                        :roles [:some [:voice-insights-user]]
                        :label "Agent"}
             :vi/agent-session {:uri "/vi/agent/:session-id"
                                :roles [:some [:voice-insights-user]]
                                :label "Agent"}
             :ai-agent/new {:uri "/ai-agent"
                            :roles [:some [:admin]]
                            :label "Agent"}
             :ai-agent/session {:uri "/ai-agent/:session-id"
                                :roles [:some [:admin]]
                                :label "Agent Session"}

             #_oasys
             :oasys/assistant-view {:uri "/oasys/assistant-view"
                                    :label "Assistant View"}

             #_reports
             :reports/list {:uri "/reports/list"
                               :roles [:some [:reports-user]]
                               :label "Reports"}
             :reports/individual {:uri "/reports/i/:report-id"
                                     :roles [:some [:reports-user]]
                                     :label "Report"}
             :reports/individual-session {:uri "/reports/i/:report-id/:session-id"
                                          :roles [:some [:reports-user]]
                                          :label "Report"}
             :reports/individual-edit {:uri "/reports/i/:report-id/edit/:session-id"
                                       :roles [:some [:admin]]
                                       :label "Edit Report"}
             :reports/new {:uri "/reports/new"
                           :roles [:some [:admin]]
                           :label "New Report"}
             :reports/new-session {:uri "/reports/new/:session-id"
                                   :roles [:some [:admin]]
                                   :label "New Report"}})
